import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    date_start: yup.string(),
    date_finish: yup.string(),
    office_id: yup.object().nullable(),
    search: yup.string(),
    category_id: yup.object().nullable(),
    group_at: yup.object().nullable(),
    group_from: yup.object().nullable(),
  });
